module.exports = __webpack_public_path__ + "img/icon-speed-7.bc14bbad.svg";